import {DeliveredPrescriptionDeliveredItem} from "../../../../types/ihioPrescriptionFilling";
import {MtoJDateFormat} from "../../../../utils/date";
import Tooltip from "../../general/tooltip";
import Icon from "../../general/icon";


type DeliveredItemCardProps = {
    item: DeliveredPrescriptionDeliveredItem;
}

const DeliveredItemCard = ({
    item,
}: DeliveredItemCardProps) => {

    return (
        <div className={`card shadow-none border rounded-4 my-3 ${item?.itemCountDelivered === item?.itemCount ? 'border-green-success bg-light-green-success' : ''}`}>
            <div className={'card-body'}>
                <div className={'d-flex align-items-center justify-content-between'}>
                    <div>
                        {MtoJDateFormat(item?.deliveredDate)} - {item?.itemCount || 0} عدد
                        - {item?.itemCountDelivered} عدد تحویل داده شده
                    </div>
                    <bdi className={'d-flex align-items-center gap-3'}>
                        {item?.itemCountDelivered === item?.itemCount && (
                            <Tooltip alt={'تحویل داده شده است'}>
                                <span className={'text-success'}>
                                    <Icon name={'check-square'}/>
                                </span>
                            </Tooltip>
                        )}
                        <div
                            className={'badge badge-primary px-2 py-2'}
                            title={item?.shape?.name}
                        />
                        <bdi>
                            {item?.name}
                        </bdi>
                    </bdi>
                </div>
                <div className={'row row-cols-md-3 row-cols-2 mt-3'}>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray ms-3'}>
                            مبلغ کل:
                        </span>
                        <span className={'text-gray2'}>
                            {item?.amount || 0}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray ms-3'}>
                            پرداختی بیمار:
                        </span>
                        <span className={'text-gray2'}>
                            {item?.patientPayment || 0}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray ms-3'}>
                            سهم سازمان:
                        </span>
                        <span className={'text-gray2'}>
                            {(item?.amount || 0) - (item?.patientPayment || 0)}
                        </span>
                    </div>
                </div>
                {item?.description && (
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray ms-3'}>
                            توضیحات:
                        </span>
                        <span className={'text-gray2'}>
                            {item?.description}
                        </span>
                    </div>
                )}
            </div>
        </div>
    )
}


export default DeliveredItemCard;